import React from 'react';

import Providers from './providers';

export default class Root extends React.PureComponent {
  render() {
    return <Providers />;
  }
}
